import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { apiGet } from 'services';
import BlobImage from 'components/blobImage';
import { Loading } from 'e4shared';

export const TeamMissingGoals = ({ profile }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    React.useEffect(() => {
        const gotResponse = response => {
            setData(response);
            setLoading(false);
        };

        Boolean(profile) && apiGet(`team-missing-goal/${profile.id}`, guid, response => gotResponse(response));
    }, [guid, profile.id]);

    return (
        <div>
            {data.map(p => {
                return loading ? (
                    <Loading />
                ) : (
                    <div key={`profile-${p.id}`}>
                        <div className="mb5 flex flex-center">
                            <BlobImage height="20" className="img-circle mr5" src={p.avatar} folder="avatar" />
                            <span className="mr5">
                                <Link to={`/develop/performance-dashboard/${p.id}`}>{p.full_Name}</Link>
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default TeamMissingGoals;
